import { createSelector } from 'reselect';
import { IRootState } from 'store';
import { IAuthState } from 'types';

export const authSelector = (state: IRootState): IAuthState => state.auth;

export const isSignedInSelector = createSelector(
  authSelector,
  (auth) => auth.isSignedIn
);
// TODO: probably, we will be able to check some field in user object
export const isNewUserSelector = createSelector(
  authSelector,
  (auth) => auth.newUser
);

export const loginErrorMessageSelector = createSelector(
  authSelector,
  (auth) => auth.loginError?.message
);

export const signupErrorMessageSelector = createSelector(
  authSelector,
  (auth) => auth.signUpError?.message
);
